
export const PLAN_NAME_OPTIONS = [
  { value: "Monthly", label: "Monthly" },
  { value: "Yearly", label: "Yearly" },
  { value: "One-Time", label: "One-Time" },
  { value: "Free Trial", label: "Free Trial" },
];
